import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input, Space } from 'antd';
import { Field } from 'formik';
import cn from 'classnames';
import classes from './Style.module.scss';
import PhoneNumber from '../PhoneNumber/index';

export default function Contact({ fieldProps, className }) {
  const { contactPerson, contactPersonEmail, contactPersonPhone } = fieldProps;

  return (
    <Row gutter={[16, 16]} wrap className={cn(classes.contact, className)}>
      <Col sm={24} lg={8}>
        <Field name={contactPerson.name}>
          {({ field }) => {
            return (
              <Space direction="vertical" className={classes.fullWidth}>
                <label>Contact Person</label>
                <Input
                  value={field.value}
                  onChange={(e) => {
                    field.onChange({
                      target: {
                        ...e.target,
                        name: contactPerson.name
                      }
                    });
                  }}
                />
              </Space>
            );
          }}
        </Field>
      </Col>
      <Col sm={24} lg={8}>
        <Field name={contactPersonPhone.name}>
          {({ field }) => {
            return (
              <Space direction="vertical" className={classes.fullWidth}>
                <label>Contact no.</label>
                <PhoneNumber
                  value={field.value}
                  onChange={(value) => {
                    field.onChange({
                      target: {
                        name: contactPersonPhone.name,
                        value
                      }
                    });
                  }}
                />
              </Space>
            );
          }}
        </Field>
      </Col>
      <Col sm={24} lg={8}>
        <Field name={contactPersonEmail.name}>
          {({ field }) => {
            return (
              <Space direction="vertical" className={classes.fullWidth}>
                <label>Email Address</label>
                <Input
                  value={field.value}
                  onChange={(e) => {
                    field.onChange({
                      target: {
                        ...e.target,
                        name: contactPersonEmail.name
                      }
                    });
                  }}
                />
              </Space>
            );
          }}
        </Field>
      </Col>
    </Row>
  );
}

Contact.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  fieldProps: PropTypes.shape({
    contactPerson: PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      defaultValue: PropTypes.string
    }),
    contactPersonEmail: PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      defaultValue: PropTypes.string
    }),
    contactPersonPhone: PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      defaultValue: PropTypes.shape({
        code: PropTypes.string,
        number: PropTypes.string,
        area: PropTypes.string
      })
    })
  }).isRequired
};

Contact.defaultProps = {
  className: null
};
// <Field name={`suppliers[${index}].contactPerson`}>
// {({ field }) => {
//   return (
//     <Space direction="vertical" className={classes.fullWidth}>
//       <label>Contact no.</label>
//       <Input
//         value={field.value}
//         onChange={(e) => {
//           field.onChange({
//             target: {
//               ...e.target,
//               name: `suppliers[${index}].contactPerson`,
//             },
//           });
//         }}
//       />
//     </Space>
//   );
// }}
// </Field>
